import React from 'react'
import { ListGroup, ListGroupItem } from 'reactstrap'
import { formatNumber } from '../../../Utils'
import { withTranslation } from 'react-i18next';

const AdditionalItem = ({
    decoration,
    decorationSelected,
    decorationPrice,
    plated,
    platedSelected,
    platedPrice,
    sequined,
    sequinedSelected,
    sequinedPrice,
    longSelected,
    longPrice,
    rufflesSelected,
    rufflesPrice,
    impregnateSelected,
    impregnatePrice,
    chiffonPrice,
    chiffonSelected,
    bibPrice,
    bibSelected,
    t
}) => (
    <ListGroup flush className="shopping-item-section">
        <ListGroupItem className="item-main-header">
            <strong>{t('cart.sections.surcharge')}</strong>
        </ListGroupItem>
        {
            longSelected &&
            <ListGroupItem className="item-button" active={longSelected}>
                <div className="d-flex item-header-font">
                    <div className="item-header">{t('cart.options.withLong')}</div>
                    <div className="small-price">
                        {formatNumber(longPrice)}
                    </div>
                </div>
            </ListGroupItem>
        }
        {
            decorationSelected &&
            <ListGroupItem className="item-button" active={decorationSelected}>
                <div className="d-flex item-header-font">
                    <div className="item-header">{plated ? t('cart.options.withDecoAndPlated') : t('cart.options.withDeco')}</div>
                    <div className="small-price">
                        {formatNumber(decorationPrice)}
                    </div>
                </div>
            </ListGroupItem>
        }
        {
            platedSelected &&
            <ListGroupItem className="item-button" active={platedSelected}>
                <div className="d-flex item-header-font">
                    <div className="item-header">{t('cart.options.withPlated')}</div>
                    <div className="small-price">
                        {formatNumber(platedPrice)}
                    </div>
                </div>
            </ListGroupItem>
        }
        {
            sequinedSelected &&
            <ListGroupItem className="item-button" active={sequinedSelected}>
                <div className="d-flex">
                    <div className="item-header">{t('cart.options.withSequins')}</div>
                    <div className="small-price">
                        {formatNumber(sequinedPrice)}
                    </div>
                </div>
            </ListGroupItem>
        }
        {
            rufflesSelected &&
            <ListGroupItem className="item-button" active={rufflesSelected}>
                <div className="d-flex">
                    <div className="item-header">{t('cart.options.withRuffles')}</div>
                    <div className="small-price">
                        {formatNumber(rufflesPrice)}
                    </div>
                </div>
            </ListGroupItem>
        }
        {
            impregnateSelected &&
            <ListGroupItem className="item-button" active={impregnateSelected}>
                <div className="d-flex">
                    <div className="item-header">{t('cart.options.withImpregnate')}</div>
                    <div className="small-price">
                        {formatNumber(impregnatePrice)}
                    </div>
                </div>
            </ListGroupItem>
        }
        {
            chiffonSelected &&
            <ListGroupItem className="item-button" active={chiffonSelected}>
                <div className="d-flex">
                    <div className="item-header">{t('cart.options.withChiffon')}</div>
                    <div className="small-price">
                        {formatNumber(chiffonPrice)}
                    </div>
                </div>
            </ListGroupItem>
        }
        {
            bibSelected &&
            <ListGroupItem className="item-button" active={bibSelected}>
                <div className="d-flex">
                    <div className="item-header">{t('cart.options.withBib')}</div>
                    <div className="small-price">
                        {formatNumber(bibPrice)}
                    </div>
                </div>
            </ListGroupItem>
        }
    </ListGroup>
)

export default withTranslation()(AdditionalItem)